<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('proyectos')">Proyecto:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.nombre}}
    </h1>
    <trashed-message v-if="proyecto.deleted_at" class="mb-6" @restore="restore">
     Proyecto Removed!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!proyecto.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Proyecto</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Guardar Proyecto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.nombre}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    proyecto: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombre: this.proyecto.nombre,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('proyectos.update', this.proyecto.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('proyectos.destroy', this.proyecto.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('proyectos.restore', this.proyecto.id))
      }
    },
  },
}
</script>
